import CheckIcon from '@mui/icons-material/Check';
import Box from '@mui/material/Box';
import React, { FC, useRef } from 'react';
import { useOnClickOutside } from 'usehooks-ts';

import { COLORS } from '../../utils';
import { toolbarStyles, zIndexValues } from '../styles';

export interface ColorCircleProps {
  color: string;
  selected?: boolean;
  handleClick: () => void;
}

export const ColorCircle: FC<ColorCircleProps> = (props) => {
  const { color, selected, handleClick } = props;
  return (
    <Box
      onClick={handleClick}
      sx={{
        borderRadius: '50%',
        backgroundColor: color,
        cursor: 'pointer',
        height: '4rem',
        width: '4rem',
        margin: 0,
        padding: 0,
        textAlign: 'center',
      }}
    >
      {selected ? (
        <CheckIcon
          fontSize="large"
          htmlColor="white"
          sx={{ height: '100%', margin: 'auto' }}
        />
      ) : null}
    </Box>
  );
};

export interface Props {
  selectedColorIndex: number | null;
  handleSelectColor: (colorIndex: number) => void;
  handleClickOutside: () => void;
}

export const ColorPickerPanel: FC<Props> = (props) => {
  const { selectedColorIndex, handleSelectColor, handleClickOutside } = props;

  const ref = useRef(null);
  useOnClickOutside(ref, handleClickOutside);

  return (
    <Box
      ref={ref}
      sx={[
        toolbarStyles,
        {
          zIndex: zIndexValues.popovers,
          position: 'absolute',
          right: '1rem',
          top: '8rem',
          padding: '0.5rem',
          display: 'grid',
          gap: '0.5rem',
          gridTemplateColumns: 'repeat(3, 1fr)',
        },
      ]}
    >
      {COLORS.map((color, i) => (
        <ColorCircle
          key={i}
          color={color}
          selected={selectedColorIndex === i}
          handleClick={() => handleSelectColor(i)}
        />
      ))}
    </Box>
  );
};
